var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.9706,
    height: 34.9706,
    rx: 17.4853,
    fill: "#1E232C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8572 18.0379C9.74876 17.8708 9.69454 17.7872 9.66419 17.6583C9.6414 17.5614 9.6414 17.4087 9.66419 17.3119C9.69454 17.183 9.74876 17.0994 9.8572 16.9322C10.7533 15.5508 13.4206 12.0586 17.4853 12.0586C21.5501 12.0586 24.2174 15.5508 25.1135 16.9322C25.2219 17.0994 25.2761 17.183 25.3065 17.3119C25.3293 17.4087 25.3293 17.5614 25.3065 17.6583C25.2761 17.7872 25.2219 17.8708 25.1135 18.0379C24.2174 19.4193 21.5501 22.9115 17.4853 22.9115C13.4206 22.9115 10.7533 19.4193 9.8572 18.0379Z",
    stroke: "white",
    strokeWidth: 1.71496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4853 19.8107C18.8046 19.8107 19.874 18.7695 19.874 17.4851C19.874 16.2007 18.8046 15.1594 17.4853 15.1594C16.1661 15.1594 15.0966 16.2007 15.0966 17.4851C15.0966 18.7695 16.1661 19.8107 17.4853 19.8107Z",
    stroke: "white",
    strokeWidth: 1.71496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.cd911b5fac1ad4450c52ce73f0d14ad7.svg";
export { ForwardRef as ReactComponent };